import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-tai-chi-walking-v2': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_less_sleep_more_calories~1
			funnel: {
				id: 'ob-female-tai-chi-walking-less-sleep',
				locale: ['en'],
			},
		},
	},
]

export default config
